<template>
  <section>
    <div class="form-content">
      <div class="clear">
        <el-col :span="10">
          <el-form-item label="申请单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请部门">
            <el-input size="small" :disabled="true" v-model="userData.childDept"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="车辆型号">
            <el-input size="small" v-model="form.xh"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发动机排量">
            <el-input size="small" v-model="form.pl"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="购置数量">
            <el-input size="small" type="number" v-model="form.amount"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="clear">
        <el-col :span="8">
          <el-form-item label="购置或更新">
            <el-radio-group size="small" v-model="form.addType" class="type-radio-type">
              <el-radio-button label="0">购置</el-radio-button>
              <el-radio-button label="1">更新</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆价格">
            <el-input size="small" type="number" v-model="form.price"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.applyTime" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </div>
      <el-form-item label="购车理由">
        <el-input type="textarea" placeholder="购车理由及用途" :autosize="{ minRows: 5, maxRows: 8}" size="small"
          v-model="form.reason"></el-input>
      </el-form-item>

    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', ],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        form: {},
      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // 返回form
      getFromData() {
        return this.form
      },
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
        this.selectLeader = [this.form.driver]
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/car/buy.vue